import { SelectorOption } from "../../../components/Redux/BasicSelector";

export const TracingOptions: SelectorOption[] = [
  { label: "None", id: "" },
  { label: "OTLP", id: "otlp" },
];

export const TracingOtlpProtocolOptions: SelectorOption[] = [
  { label: "auto", id: "" },
  { label: "grpc", id: "grpc" },
  { label: "http/protobuf", id: "http/protobuf" },
];
